export var MainFilterFieldType;
(function (MainFilterFieldType) {
    MainFilterFieldType["NUMBER"] = "number";
})(MainFilterFieldType || (MainFilterFieldType = {}));
export var MainFilterFieldCategory;
(function (MainFilterFieldCategory) {
    MainFilterFieldCategory[MainFilterFieldCategory["PRE_SET"] = 1] = "PRE_SET";
})(MainFilterFieldCategory || (MainFilterFieldCategory = {}));
